module.exports = __webpack_public_path__ + "media/usecase_enterprise_06.14f6d99e.mp4";